import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "影视作品", path: "/works" },
  { label: "个人资料", path: "/profile" },
  { label: "新闻资讯", path: "/news" },
  { label: "联系", path: "/contact" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-sm border-b border-background-200"
      }`}
    >
      <div className="px-4 md:px-8">
        <div className="h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <span
              className={`w-10 h-10 rounded-full flex items-center justify-center font-heading text-lg font-semibold transition-colors ${
                transparent
                  ? "bg-background-50/90 text-foreground-950"
                  : "bg-primary-500 text-background-50"
              }`}
            >
              淇
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg md:text-xl font-semibold tracking-wide transition-colors ${
                  transparent ? "text-background-50" : "text-foreground-950"
                }`}
              >
                舒淇
              </span>
              <span
                className={`text-[10px] tracking-[0.3em] uppercase transition-colors ${
                  transparent ? "text-background-100/80" : "text-secondary-500"
                }`}
              >
                Shu Qi
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? transparent
                        ? "text-background-50 bg-background-50/15"
                        : "text-primary-500 bg-primary-50"
                      : transparent
                        ? "text-background-100/90 hover:text-background-50 hover:bg-background-50/10"
                        : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/works"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-film-line" />
              浏览作品
            </Link>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen(true)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
              transparent
                ? "text-background-50 hover:bg-background-50/15"
                : "text-foreground-950 hover:bg-background-100"
            }`}
          >
            <i className="ri-menu-3-line text-2xl" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden fixed inset-0 z-[60] bg-foreground-950/95 animate-fade-in">
          <div className="flex items-center justify-between h-16 px-4">
            <span className="font-heading text-lg text-background-50">舒淇</span>
            <button
              type="button"
              aria-label="关闭菜单"
              onClick={() => setMenuOpen(false)}
              className="w-10 h-10 flex items-center justify-center rounded-md text-background-50 hover:bg-background-50/15 cursor-pointer"
            >
              <i className="ri-close-line text-2xl" />
            </button>
          </div>
          <nav className="flex flex-col px-6 pt-6 gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `py-4 text-xl font-heading border-b border-background-50/10 transition-colors ${
                    isActive ? "text-accent-400" : "text-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}